import { Component, Input, Output, EventEmitter, Injector, OnInit } from '@angular/core';
import { AppComponentBase } from '@shared/app-component-base';
import { CustomCommon } from '@shared/custom-common/custom-common';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';

@Component({
    selector: 'multi-select-dropdown',
    templateUrl: './multi-select-dropdown.component.html'
})
export class MultiSelectDropdownComponent extends AppComponentBase implements OnInit {
    @Input() placeholder: string;
    @Input() data: any;
    @Input() primaryKey: string;
    @Input() labelKey: string;
    @Input() inputModel: any;
    @Input() disabled: boolean;
    @Input() required: boolean;
    @Output() inputModelChange = new EventEmitter<string>();
    @Output() valid = new EventEmitter();
    multiDropdownSettings: AngularMultiSelectModule;
    showMessageError: boolean;
    firstLoad: number;
    constructor(injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        if (this.placeholder == undefined) {
            this.placeholder = CustomCommon.ChooseOneValue;
        }
        if (this.primaryKey == undefined) {
            this.multiDropdownSettings = {
                text: this.l(CustomCommon.ChooseOneValue),
                singleSelection: true,
                enableSearchFilter: true,
                primaryKey: CustomCommon.MasterListCode,
                labelKey: CustomCommon.MasterListCdeName,
                badgeShowLimit: 5,
                allowSearchFilter: true,
                searchBy: [CustomCommon.MasterListCdeName],
                searchPlaceholderText: this.l(CustomCommon.SearchWithThreeDot),
                noDataAvailablePlaceholderText: this.l(CustomCommon.NoDataAvailable),
                noFilteredDataAvailablePlaceholderText: this.l(CustomCommon.NoDataAvailable)
            };
        }
        else {
            this.multiDropdownSettings = {
                text: this.l(CustomCommon.ChooseOneValue),
                enableSearchFilter: true,
                primaryKey: this.primaryKey,
                labelKey: this.labelKey,
                badgeShowLimit: 5,
                singleSelection: true,
                allowSearchFilter: true,
                searchBy: CustomCommon.MasterListCdeName,
                searchPlaceholderText: this.l(CustomCommon.SearchWithThreeDot),
                noDataAvailablePlaceholderText: this.l(CustomCommon.NoDataAvailable),
                noFilteredDataAvailablePlaceholderText: this.l(CustomCommon.NoDataAvailable)
            };
        }

        this.showMessageError = false;
        this.firstLoad = 0;
    }

    inputModelChangeEvent(event) {
        this.inputModelChange.emit(event);
        if (this.required === true) {
            if (event === undefined || event.length === 0) {
                this.showMessageError = true
            }
            else {
                this.showMessageError = false;
            }
            this.valid.emit(this.showMessageError); 

            if(this.firstLoad < 2)
            {
                this.showMessageError = false;
                this.firstLoad++;
            }
        }
    }
}
